/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { boolean as codecBoolean, number as codecNumber } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { AbstractRole } from './AbstractRole';
import { GlobalPermMap } from './GlobalPermMap';
const TenantRoleAsJSONWithPermsParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['perms', GlobalPermMap],
    ['own', codecBoolean],
    ['count', codecNumber],
]), AbstractRole);
export class TenantRoleAsJSONWithPerms extends AbstractRole {
    static decode(input) {
        return TenantRoleAsJSONWithPermsParser.decode(input).map(res => new TenantRoleAsJSONWithPerms(res));
    }
    static unsafeDecode(input) {
        return TenantRoleAsJSONWithPerms.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TenantRoleAsJSONWithPermsParser.encode(data);
    }
    static schema() {
        return TenantRoleAsJSONWithPermsParser.schema();
    }
}
